import { render, staticRenderFns } from "./BpOtherIncomeExtraOrdinaryIncomeNumberDisplayer.vue?vue&type=template&id=4b0ffcab"
import script from "./BpOtherIncomeExtraOrdinaryIncomeNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpOtherIncomeExtraOrdinaryIncomeNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports